//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { COUNTRY_GB } from '~/utils/constants'

export default {
  props: {
    template: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showLanguage () {
      return this.$country.current.countryCode !== COUNTRY_GB
    },
    categories () {
      if (!this.template) { return [] }

      const categories = []
      this.template.categories.forEach((category) => {
        if (!categories.find(c => c.name === category.name)) {
          categories.push(category)
        }
      })

      return categories.slice(0, 4)
    },
  },
  methods: {
    createContract () {
      this.$emit('create')
    },
    openVideo (id) {
      this.$store.commit('layout/SET_OPENED_VIDEO', id)
    },
  }
}
